// Single City (CPT `city`) — guarded so it only runs on single-city.php.
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.single-city');
    if (!root) {
        return;
    }

    // Плавный скролл по внутренним якорям контента города.
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var target = document.querySelector(link.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });
});
